import { applyBrandCssVariables } from "./brandTokens";

applyBrandCssVariables();
